import { api } from "../../lib/api";

const CHUNK = 4 * 1024 * 1024;
export const MAX_VIDEO = 100 * 1024 * 1024;

export async function uploadVideo(file, fields, onProgress) {
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  const id = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`).replace(/[^A-Za-z0-9-]/g, "");
  let res;
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("chunk", file.slice(i * CHUNK, (i + 1) * CHUNK), "chunk");
    Object.entries({ upload_id: id, index: i, total, filename: file.name, ...fields }).forEach(([k, v]) => v !== undefined && v !== "" && v !== null && fd.append(k, v));
    res = (await api.post("/videos/chunk", fd)).data;
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }
  return res;
}
